const getMarkerVRXml = function (krpanoVrModeObj) {
  let vr = ''
  krpanoVrModeObj.vrModeShouldShow.push('markerInfoHover')
  vr += `
  <hotspot
    name="markerInfoHover"
    style="markerInfo"
    scale="0"
    visible="false"
    enabled="false"
    zorder="2"
    type="text" />`
  krpanoVrModeObj.vrModeShouldShow.push('markerInfoBg')
  krpanoVrModeObj.vrModeShouldShow.push('markerCloseButton')
  krpanoVrModeObj.vrModeShouldShow.push('markerFavoriteButton')
  krpanoVrModeObj.vrModeShouldShow.push('markerInfoTitle')
  krpanoVrModeObj.vrModeShouldShow.push('markerInfoDescription')
  krpanoVrModeObj.vrModeShouldShow.push('markerInfoPrice')
  vr += `
  <hotspot
    name="markerCloseButton"
    style="markerButton"
    url="${require('../img/button/x-default.png')}"
    zorder="999"
    scale="0"
    edge="lefttop"/>
  <hotspot
    name="markerFavoriteButton"
    style="markerButton"
    url="${require('../img/button/star-default.png')}"
    zorder="999"
    scale="0"
    edge="lefttop"/>
  <hotspot
    name="markerInfoBg"
    style="markerInfoTagBg"
    scale="0"
    visible="false"
    zorder="998"
    type="text"/>
  <hotspot
    name="markerInfoTitle"
    style="markerInfoTag"
    css="font-family:Barlow; font-size:24px; color:#fff; font-weight: 700;"
    edge="lefttop"
    scale="0"
    visible="false"
    zorder="999"
    enabled="false"
    type="text" />
  <hotspot
    name="markerInfoDescription"
    style="markerInfoTag"
    css="font-family:Barlow; font-size:14px; color:#fff; font-weight: 500;"
    edge="lefttop"
    scale="0"
    visible="false"
    zorder="999"
    enabled="false"
    type="text" />
  <hotspot
    name="markerInfoPrice"
    style="markerInfoTag"
    css="font-family:Barlow; font-size:24px; color:#fff; font-weight: 700;"
    edge="lefttop"
    scale="0"
    visible="false"
    enabled="false"
    zorder="999"
    type="text" />`
  return vr
}

export default getMarkerVRXml
